import { render, staticRenderFns } from "./WorldViewDetail.vue?vue&type=template&id=2bfa5a10&scoped=true"
import script from "./WorldViewDetail.vue?vue&type=script&lang=ts"
export * from "./WorldViewDetail.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewDetail.vue?vue&type=style&index=0&id=2bfa5a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa5a10",
  null
  
)

export default component.exports